export const PROCESS_TYPES = {
  ANONYMIZATION: "anonymization",
  PSEUDONYMIZATION: "pseudonymization",
  DEPSEUDONYMIZATION: "depseudonymization",
  VALIDATION: "validation",

  DICOM_PSEUDONYMIZATION: "dicom_pseudonymization",
  DICOM_DEPSEUDONYMIZATION: "dicom_depseudonymization",
};